import { TranslateFn, TranslationKey } from "models/translation";
import { OptionInterface } from "./dropdown.styles";
import { FieldDataType } from "models/generic";
import { Locale } from "models/locale";

export const getDatatypeOptions = (translate: TranslateFn) => {
  const datatype: FieldDataType[] = [
    "text",
    "textarea",
    "email",
    "date",
    "datetime",
    "dropdown",
    "check",
    "ssn",
    "phone",
    //"radio", // disabled for now
  ];

  const options: OptionInterface[] = datatype.map((dt) => {
    const key: TranslationKey = `field_datatype_${dt}`;
    return {
      value: dt,
      text: translate(key),
    };
  });

  return options;
};

export const getLanguageOptions = (
  locales: Locale[],
  translate: TranslateFn,
): OptionInterface[] => {
  return locales.map((locale) => {
    return { value: locale, text: translate(`locale_${locale}`) };
  });
};
